
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySnow as ObiLightningHeavySnowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-snow.js';
 
 
 

 
 export const ObiLightningHeavySnow = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-snow',
   elementClass: ObiLightningHeavySnowElement,
   events: {
     
   }
  });
 
 